<template>
    <div
        class="dialog adjust-gardner-dialog py-1 display-flex column"
        :class="{ 'dialog-opened': showAdjustGardnerDialog }"
        @click="$event.stopImmediatePropagation()"
    >
        <div class="display-flex column w-100">
            <div class="justify-center pt-4 pb-3 px-4">
                <b-dropdown :text="expansion || ''" size="lg" class="border mr-3">
                    <b-dropdown-item
                        v-for="index in 4"
                        :key="index"
                        href="#"
                        @click="expansion = index + ''"
                    >
                        {{ index }}
                    </b-dropdown-item>
                </b-dropdown>

                <b-dropdown :text="icm || ''" size="lg" class="border mr-3">
                    <b-dropdown-item
                        v-for="index in ['A', 'AB', 'B', 'BC', 'C']"
                        :key="index"
                        href="#"
                        @click="icm = index"
                    >
                        {{ index }}
                    </b-dropdown-item>
                </b-dropdown>

                <b-dropdown :text="te || ''" size="lg" class="border">
                    <b-dropdown-item
                        v-for="index in ['A', 'AB', 'B', 'BC', 'C']"
                        :key="index"
                        href="#"
                        @click="te = index"
                    >
                        {{ index }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>

            <span class="mb-3 mx-4" v-html="$translate('are_you_sure_make_this_change')"></span>

            <div class="h-divider"></div>

            <div class="w-100 justify-between py-3 px-4">
                <b-button class="pl-0" variant="link" @click="cancel">
                    {{ $translate('cancel') }}
                </b-button>

                <b-button class="ml-auto px-4 text-dark-2 h-100" variant="primary" @click="save">
                    {{ $translate('save') }}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AdjustGardnerDialog',
    props: ['patient', 'slide'],
    data() {
        return {
            expansion: null,
            icm: null,
            te: null
        }
    },
    computed: {
        showAdjustGardnerDialog() {
            return this.$store.state.timelapse.showAdjustGardnerDialog
        }
    },
    methods: {
        save() {
            // todo: adjustGardner
            this.hide()
        },
        cancel() {
            this.hide()
        },
        hide() {
            this.$store.state.timelapse.showAdjustGardnerDialog = false

            this.expansion = null
            this.icm = null
            this.te = null
        }
    }
}
</script>
